import { Fragment, useEffect, useMemo } from 'react';
// components
import { Page } from 'theme/elements/Page';
// sections
import AddBalanceProcess from 'sections/balance/addBalance/shared';
import AddBalanceDashboard from 'sections/balance/addBalance';
// reducers
import { loadingCurrencies } from 'state/reducers/global.reducers';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { getMessage, setMessage, setAddBalanceState, getAddBalanceState } from 'state/reducers/balance.reducers';
import { selectTranslations } from 'state/reducers/translation.reducers';
import WarningDialog from 'components/WarningDialog';
import { BalanceDepositType } from 'constants/balance.constants';

export default function BalanceApp() {
	const dispatch = useAppDispatch();
	const t = useAppSelector(selectTranslations);
	const getLoadingCurrencies = useAppSelector(loadingCurrencies);
	const userMessage = useAppSelector(getMessage);
	const addBalanceState = useAppSelector(getAddBalanceState);

	const openDialog = useMemo(() => {
		return userMessage.exist;
	}, [userMessage]);

	useEffect(() => {
		dispatch(setAddBalanceState('dashboard'));
	}, []);

	const handleClose = () => {
		dispatch(setAddBalanceState('dashboard'));
	};

	return (
		<Fragment>
			<Page>
				<Fragment>
					<WarningDialog
						open={openDialog}
						title={t(userMessage.text || '')}
						subTitle={userMessage.subText}
						handleCancel={() => {
							dispatch(setMessage({ exist: false }));
						}}
					/>
					{!getLoadingCurrencies.loadingCurrencies &&
						getLoadingCurrencies.startLoadingCurrencies &&
						((addBalanceState === 'dashboard' && <AddBalanceDashboard />) ||
							((addBalanceState === BalanceDepositType.Manual ||
								addBalanceState === BalanceDepositType.Digital) && (
								<AddBalanceProcess handleClose={handleClose} />
							)))}
				</Fragment>
			</Page>
		</Fragment>
	);
}
